import Certificate from './Certificate'

export default Certificate
